import React from 'react'
import './button.css'

function FilledSquareButton({onClickHandler, name, color, size="large", disable=false}) {
    return (
        <button type="button" disabled={disable} className={`filled filled-square-button rounded ${size} ${color}`} onClick={onClickHandler}>{name}</button>
    )
}

export default FilledSquareButton